import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Macrocycle } from "../../../../interfaces/planning";

interface MacrocycleModalProps {
    show: boolean;
    selectedWeeks: string[];
    editingMacrocycle?: Macrocycle | null;
    onSave: (name: string, color: string) => void;
    onClose: () => void;
}

export function MacrocycleModal(props: MacrocycleModalProps) {
    const [name, setName] = useState('');
    const [color, setColor] = useState('#ffcccc');

    // Update form when editing a macrocycle
    useEffect(() => {
        if (props.editingMacrocycle) {
            setName(props.editingMacrocycle.name);
            setColor(props.editingMacrocycle.color);
        } else {
            setName('');
            setColor('#ffcccc');
        }
    }, [props.editingMacrocycle, props.show]);

    const handleSave = (event: any) => {
        event.preventDefault();
        if (name.trim() === '') {
            alert(t("Please enter a name for the macrocycle"));
            return;
        }
        props.onSave(name, color);
        setName('');
        setColor('#ffcccc');
    }

    const handleClose = () => {
        setName('');
        setColor('#ffcccc');
        props.onClose();
    }

    const weeks = props.editingMacrocycle ? props.editingMacrocycle.weeks : props.selectedWeeks;
    const isEditing = !!props.editingMacrocycle;

    return (
        <Modal show={props.show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isEditing ? t("Edit Macrocycle") : t("Define Macrocycle")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave}>
                    <Form.Group className="mb-3">
                        <Form.Label>{t("Selected weeks")}: {weeks.length}</Form.Label>
                        <div className="text-muted small">
                            {weeks.join(', ')}
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="macrocycleName">
                        <Form.Label>{t("Macrocycle name")}</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("e.g., General Preparation")}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="macrocycleColor">
                        <Form.Label>{t("Background color")}</Form.Label>
                        <div className="d-flex align-items-center gap-2">
                            <Form.Control
                                type="color"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                style={{ width: '60px', height: '40px' }}
                            />
                            <Form.Control
                                type="text"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                placeholder="#ffcccc"
                            />
                        </div>
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Cancel")}
                        </Button>
                        <Button variant="primary" type="submit">
                            {t("Save")}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
